import React, { useState, useEffect } from "react";
import moment from "moment";
import DataTable from "react-data-table-component";
import DialogComponent from "../reusableComponents/Dialog";
import TableComponent from "../reusableComponents/Table";
import { RFTfeature } from "../features/RFTfeature";
import Loader from "../components/Loader";
import { Button, Box, Grid } from "@mui/material";
import { BodyContainer, Header, TopGrid } from "../styles";
import SearchIcon from "@mui/icons-material/Search";
import { InputAdornment, TextField, Typography, styled } from "@mui/material";
import DateField from "../components/DateField";
import Repo from "../../Repository/Repo";

const SearchField = styled(TextField)({
  borderRadius: "4px",
  fontSize: "12px",
  height: "40px",
  lineHeight: "14.06px",
  backgroundColor: "#f9f9f9",
  boxShadow: "0px 4px 16px rgba(0, 0, 0, 0.16)",
  borderBottom: "1px solid #999999 !important",
});

const customStyles = {
  rows: {
    style: {
      minHeight: "60px",
      background: "white",
      padding: "2px 10px",
      marginTop: "5px",
    },
  },
  header: {
    style: {
      color: "#4EAF50",
      marginTop: "5px !important",
    },
  },
  headCells: {
    style: {
      backgroundColor: "#4EAF50",
      color: "white",
      fontSize: "16px",
    },
  },
  cells: {
    style: {
      paddingLeft: "18px",
    },
  },
  table: {
    style: {
      background: "#EBEBEB",
      marginBottom: "20px",
    },
  },
};

const columns = [
  {
    name: "#",
    width: "100px",
    selector: (row, index) => index + 1,
  },
  {
    name: "Name",
    cell: (row) => {
      if (row.action == "Removed" || row.action == "Created") {
        return row?.item?.name;
      } else {
        return row?.new_item?.name;
      }
    },
  },
  {
    name: "Desc",
    cell: (row) => {
      if (row.action == "Removed" || row.action == "Created") {
        return row?.item?.description;
      } else {
        return row?.new_item?.description;
      }
    },
  },
  {
    name: "Date",
    selector: (row) =>
      moment.unix(row?.created_at).format("DD/MM/YYYY hh:mm:ss"),
  },

  {
    name: "User",
    selector: (row) => row?.user,
  },
  {
    name: "Action",
    selector: (row) => row?.action,
  },
  {
    name: "Qty",
    width: "110px",
    selector: (row) => {
      if (RFTfeature()) {
        if (row.saleType == "serviceRFT" || row.saleType == "RFT") {
          if (
            row?.action === "Added" ||
            row?.action === "Sold" ||
            row?.action === "Returned"
          ) {
            return (
              Math.abs(
                row?.new_item.quantity * 328 - row?.old_item.quantity * 328
              ) +
              " " +
              "RFT"
            );
          } else if (row?.action === "Updated") {
            return row?.new_item.quantity * 328 + " " + "RFT";
          } else if (row?.action === "Created" || row?.action === "Removed") {
            return row?.item.quantity * 328 + " " + "RFT";
          }
        } else {
          if (
            row?.action === "Added" ||
            row?.action === "Sold" ||
            row?.action === "Returned"
          ) {
            return Math.ceil(
              Math.abs(row?.new_item.quantity - row?.old_item.quantity)
            );
          } else if (row?.action === "Updated") {
            return Math.ceil(row?.new_item.quantity);
          } else if (row?.action === "Created" || row?.action === "Removed") {
            return Math.ceil(row?.item.quantity);
          }
        }
      } else {
        if (
          row?.action === "Added" ||
          row?.action === "Sold" ||
          row?.action === "Returned"
        ) {
          if (row?.new_item.weightType != true) {
            return Math.abs(row?.new_item.quantity - row?.old_item.quantity);
          } else if (row?.new_item.weightType == true) {
            return Math.abs(row?.new_item.weight - row?.old_item.weight);
          }
        } else if (row?.action === "Updated") {
          return row?.new_item.quantity;
        } else if (row?.action === "Created" || row?.action === "Removed") {
          return row?.item.quantity;
        }
      }
    },
  },
];

const headRow = ["Date", "Action", "Old Value", "Change", "New Value"];
const tableBody = [`created_at`, `action`, `oldValue`, `change`, `newValue`];

function Summary() {
  const companyCode = localStorage.getItem("companyCode");
  const [summary, setSummary] = useState([]);
  const [searched, setSearched] = useState([]);
  const [itemHistory, setItemHistory] = useState([]);
  const [state, setState] = useState({
    loading: false,
    searchText: "",
    date: "",
    modal: false,
    searched: false,
    searchLoading: false,
    historyLoading: false,
    searching: false,
    saleType: "",
    nextPageToken: "",
    next_page_token: "",
  });
  useEffect(() => {
    getSummary();
  }, []);

  const getSummary = async () => {
    setState((prev) => ({ ...prev, loading: true }));
    let { data } = await Repo.default({
      request: {
        method: "getSummaryWithPagination",
        data: {
          company_code: companyCode,
          next_page_token: state.nextPageToken,
        },
      },
    });
    setSummary((prev) => [...prev, ...data.response.data.summary]);
    setState((prev) => ({
      ...prev,
      loading: false,
      nextPageToken: data.response.data?.next_page_token || "",
    }));
  };
  const handleInput = (e) => {
    const { name, value } = e.target;
    if (value == "") {
      setState((prev) => ({
        ...prev,
        [name]: value,
        next_page_token: "",
        searched: false,
      }));
      setSearched([]);
    } else {
      if (name == "date") {
        if (value) {
          handleSearch(value);
        }
      }
      setState((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleKeyDown = (e) => {
    if (e.key == "Enter") {
      handleSearch();
    }
  };
  const handleSearch = async (arg) => {
    let date = arg ? arg : state.date;
    toggle("searchLoading");
    if (state.next_page_token == "") {
      setSearched([]);
    }
    let { data } = await Repo.default({
      request: {
        method: "getSummaryWithPagination",
        data: {
          company_code: localStorage.getItem("companyCode"),
          itemName: state.searchText,
          startDate: date ? moment(date).format("DD-MM-YYYY") : "",
          endDate: date ? moment(date).format("DD-MM-YYYY") : "",
          next_page_token: state.next_page_token,
        },
      },
    });

    let next_page_token = data.response.data.next_page_token;
    let records = data.response.data.summary;
    if (records.length > 0) {
      setSearched((prev) => [...prev, ...records]);
      setState((prev) => ({
        ...prev,
        searchLoading: false,
        next_page_token,
        searched: false,
      }));
    } else {
      setState((prev) => ({
        ...prev,
        searchLoading: false,
        next_page_token,
        searched: true,
      }));
    }
  };

  const getItemDetails = async (newName) => {
    setState((prev) => ({ ...prev, historyLoading: true }));
    let { data } = await Repo.default({
      request: {
        method: "getItemHistoryByName",
        data: {
          company_code: companyCode,
          name: newName,
        },
      },
    });
    setItemHistory(data.response.data.quantity);
    setState((prev) => ({
      ...prev,
      historyLoading: false,
    }));
  };
  function showModal(row) {
    toggle("modal");
    if (row.action == "Created" || row.action == "Removed") {
      getItemDetails(row?.item?.name);
      if (RFTfeature()) {
        setState((prevState) => ({ ...prevState, saleType: row.saleType }));
      }
    } else if (
      row.action == "Sold" ||
      row.action == "Updated" ||
      row.action == "Returned"
    ) {
      getItemDetails(row?.new_item?.name);
      if (RFTfeature()) {
        setState((prevState) => ({ ...prevState, saleType: row.saleType }));
      }
    }
  }

  const toggle = (name) => {
    setState((prev) => ({ ...prev, [name]: !prev[name] }));
  };

  const handleLoadMore = () => {
    if (searched.length > 0 && state.searchText) {
    } else {
      getSummary();
    }
  };
  const filtered = () => {
    if (state.searched && searched.length == 0) {
      return [];
    } else if (searched.length > 0) {
      return searched;
    } else {
      return summary;
    }
  };

  return (
    <Box>
      <Header sx={{ mt: { md: "0px", xs: "40px" } }}>
        <TopGrid container alignItems="center" spacing={1}>
          <Grid item md={3} xs={12}>
            <SearchField
              size="small"
              height="40px"
              placeholder="seach ..."
              variant="outlined"
              name={"searchText"}
              value={state.searchText}
              onChange={handleInput}
              onKeyDown={handleKeyDown}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon className="gray-clr" />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid align="center" item md={6} xs={12}>
            <Typography
              variant="h5"
              sx={{ color: "white", fontSize: { md: "1.5rem", xs: "14px" } }}
            >
              Summary
            </Typography>
          </Grid>
          <Grid align="center" item md={3} xs={10}>
            <DateField
              name={"date"}
              value={state.date}
              onChange={handleInput}
            />
          </Grid>
        </TopGrid>
      </Header>
      <BodyContainer
        sx={{ position: "relative", top: { md: "0px", xs: "40px" } }}
      >
        {!state.searchLoading && (
          <DataTable
            columns={columns}
            data={filtered()}
            Clicked
            highlightOnHover
            pointerOnHover
            customStyles={customStyles}
            onRowClicked={(row) => showModal(row)}
          />
        )}
        {!state.loading && !state.searchLoading && filtered().length >= 99 && (
          <Box sx={{ my: 1, display: "flex", justifyContent: "center" }}>
            <Button
              variant="outlined"
              sx={{ width: "150px" }}
              onClick={handleLoadMore}
            >
              Load More
            </Button>
          </Box>
        )}

        <DialogComponent
          title="Item History"
          open={state.modal}
          onClose={() => toggle("modal")}
          onClickCancel={() => toggle("modal")}
          dialogTitle={"Summary"}
          dialogContent={
            <>
              {state.historyLoading == true && (
                <Loader loading={state.historyLoading} />
              )}
              {state.historyLoading == false && (
                <TableComponent
                  headRow={headRow}
                  rows={itemHistory}
                  tableBody={tableBody}
                  saleType={state.saleType}
                />
              )}
            </>
          }
        />

        <Loader loading={state.loading || state.searchLoading} />
      </BodyContainer>
    </Box>
  );
}

export default Summary;
